/**
 * @deprecated Use `useComposerRuntime().cancel()` instead. This will be removed in 0.6.
 */
export { useComposerCancel } from "./useComposerCancel";
/**
 * @deprecated Use `useComoser(c => c.isEditing)` instead. This will be removed in 0.6.
 */
export { useComposerIf } from "./useComposerIf";
/**
 * @deprecated Use `useComposerRuntime().send()` instead. This will be removed in 0.6.
 */
export { useComposerSend } from "./useComposerSend";

/**
 * @deprecated Use `useComposerRuntime().addAttachment()` instead. This will be removed in 0.6.
 */
export { useComposerAddAttachment } from "./useComposerAddAttachment";
